export const relationFieldName = "relations";
export const removeValue = "0";
